import * as React from 'react';

import { GridMonthsProps } from '../../components/grid/months';
import GridMonth from '../../components/grid/month';
import LoadMore from '../../components/month-selection/load-more';

const GridMonthsView: React.StatelessComponent<GridMonthsProps> = props => {
    let firstIndexWithPerfs = 0;
    for (let i = 0; i < props.monthsData.length; i++) {
        if (props.monthsData[i].events.allDays.length > 0) {
            firstIndexWithPerfs = i;
            break;
        }
    }

    return (
        <section className="ace-cal-grid">
            <ul className="ace-cal-grid-months" aria-label={props.text.gridViewHeading}>
                {
                    props.monthsData.map((monthData, index) => <GridMonth key={`${monthData.monthMoment.month()}${monthData.monthMoment.year()}`} monthData={monthData} showDaysOfWeek={firstIndexWithPerfs == index} todaysDate={ props.todaysDate } />)
                }
            </ul>
            <LoadMore />
        </section>
    )
}

export default GridMonthsView;